export const StanningLogCategories = [
  {
    type: "DIARY",
    name: "덕질일기",
  },
  {
    type: "TO_DO_LIST",
    name: "투두리스트",
  },
  {
    type: "ARCHIVE",
    name: "아카이브",
  },
  {
    type: "NOTES",
    name: "후기가이드",
  },
  {
    type: "TIP",
    name: "덕질팁",
  },
  {
    type: "ETC",
    name: "기타",
  },
];
